
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ModalView from '@/components/helper/modal-view.vue';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import Zone from '@/store/entities/admin/zone';
    
    @Component({
        components: { ModalView },
        watch: {
            value: function (val) {
                let obj = (this as any);
                obj.modalShow = val;
            },
            modalShow: function (val) {
                if (!val) {
                    this.$emit('input', false);
                } else {
                    (this as any).initForm();
                }
            }
        }
    })

    export default class ZoneForm extends ListBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        zone: Zone = new Zone();
        modalShow: boolean = false;
        formBase: boolean = true;
        image: any = null;
        modalSetting: any = {
            entity: "zone",
            title: 'Zona',
            width: "600px",
        };
         
        items = [
            this.gItem({ type: 'object', prop: 'manager_id', entity: 'employee', label: 'Jefe', itemText: 'fullname', size: 12 }),
            this.gItem({ type: 'object', prop: 'supervisor_id', entity: 'employee', label: 'Supervisor', itemText: 'fullname', size: 12}),
            this.gItem({ type: 'text', prop: 'name', label: 'Nombre', size: 12, required: true }),
            this.gItem({ type: 'color', prop: 'color', label: 'Color', size: 12 }),     
        ]


        initForm() {   
        }

        async save() {
            this.$emit('save-success');
            this.$emit('input', false);
        }

        cancel() {
            this.$emit('input', false);
        }

        mounted() {
        }

        created() {
        }
    }
